import httpClient from "../httpClient";
import { TokenService } from "../storage.service";
import { request } from "services/api/util";
const END_POINT = "Account";

class AccountService {
  async login(user) {
    const params = {
      username: user.username,
      password: user.password,
    };

    const config = {
      method: "post",
      url: `login`,
      data: params,
      headers: {
        "content-type": "	application/json;charset=UTF-8",
      },
    };

    return request(config);
  }

  async logout() {
    const params = {
      refreshToken: TokenService.getRefreshToken(),
    };

    const config = {
      method: "post",
      url: `${END_POINT}/Logout`,
      data: params,
      headers: {
        "content-type": "application/json",
      },
    };

    const response = await httpClient(config);

    TokenService.removeToken();
    TokenService.removeRefreshToken();

    return response;
  }

  async refreshToken() {
    const config = {
      method: "post",
      url: `${END_POINT}/RefreshToken`,
      data: {
        refreshToken: TokenService.getRefreshToken(),
      },
      headers: {
        Authorization: null,
      },
    };
    const response = await httpClient(config);

    if (response?.data && response.resStatusCode === 200) {
      const { accessToken, refreshToken } = response.data;
      if (accessToken && refreshToken) {
        TokenService.saveToken(accessToken);
        TokenService.saveRefreshToken(refreshToken);
      }
    }

    return response.data;
  }

  async changepassword(param) {
    const data = {
      UserId: param.userId,
      CurrentPassword: param.currentpassword,
      NewPassword: param.password,
    };

    const config = {
      method: "put",
      url: `${END_POINT}/ChangePassword`,
      data: data,
    };

    const response = await httpClient(config);

    console.log("res:changepassword", response);

    if (response?.data && response.resStatusCode === 200) {
      const { status } = response.data;
      if (status === true) {
        return true;
      }
    }
    return false;
  }
}

export default new AccountService();
